import Circle from "../../../../../../../src/entities/Circle";
import BasePointManager from "../../../../../../../src/managers/BasePointManager";
import { normalizeRadian } from "../../../../../../../src/utils/math/normalizeRadian";
import { ANGLE_NAMES_FOR_ANIM } from "../../../types/Config";
import { RedPointRadianInfo } from "../../../types/Interface";
import AngleManager from "../../AngleManager";
import LineManager from "../../LineManager";


export function generateRotationAngles(PointManager:BasePointManager, offsetAngle: number) {
  const refAngles = PointManager.getInitialRadians();
  const getRadian = (index: number) => normalizeRadian(refAngles[index] + offsetAngle);
  const redPointRadians: RedPointRadianInfo[] = PointManager.getRedPoints()
    .map((rP, rPI) => ({ pTag: rP.tag, radian: getRadian(rPI) }))
  PointManager.setRadian(redPointRadians);
}

export function drawRotationCB(radian:number, circle:Circle, PointManager:BasePointManager, LineManager:LineManager, AngleManager:AngleManager) {
  const points = PointManager.getPoints();
  const radians = PointManager.getRadians();
  generateRotationAngles(PointManager, radian);

  circle.draw({ radians, radius: circle.radius })
  LineManager.draw(points);
  AngleManager.draw(points, true);
  AngleManager.centerAngle.AngleValue.setValue(ANGLE_NAMES_FOR_ANIM.center);
  AngleManager.circumAngle.AngleValue.setValue(ANGLE_NAMES_FOR_ANIM.circum);
}
